import styles from '../StepPanel.module.scss';
import type { DisplayStatus } from './buildPatch';

export function statusLabelKey(status: DisplayStatus): string {
  switch (status) {
    case 'not_started':
      return 'wearing.progress.statusNotStarted';
    case 'wearing':
      return 'wearing.progress.statusWearing';
    case 'paused':
      return 'wearing.progress.statusPaused';
    case 'completed':
      return 'wearing.progress.statusCompleted';
  }
}

export function statusBadgeClass(status: DisplayStatus): string {
  switch (status) {
    case 'not_started':
      return styles.statusBadgeNotStarted;
    case 'wearing':
      return styles.statusBadgeWearing;
    case 'paused':
      return styles.statusBadgePaused;
    case 'completed':
      return styles.statusBadgeCompleted;
  }
}

export function progressFillClass(status: DisplayStatus): string {
  switch (status) {
    case 'not_started':
      return styles.progressFillNotStarted;
    case 'wearing':
      return styles.progressFillWearing;
    case 'paused':
      return styles.progressFillPaused;
    case 'completed':
      return styles.progressFillCompleted;
  }
}

export function clampPercent(value: number): number {
  if (!Number.isFinite(value)) return 0;
  if (value < 0) return 0;
  if (value > 100) return 100;
  return value;
}
